import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-confirm-animation',
  templateUrl: './confirm.animation.html',
  styleUrls: ['./confirm.animation.scss']
})
export class ConfirmAnimation implements OnInit {

  @Input() message = '';

  constructor() { }

  ngOnInit() {
  }
}